import { deserialize } from 'cerialize'

export class StatusActModel {
	@deserialize public status_slug: string
	@deserialize public status_slug_translate: string

	public get id(): string {
		return this.status_slug
	}
	public get name(): string {
		return this.status_slug_translate
	}
}
